export default "__VITE_PUBLIC_ASSET__50af3c05__"